<template>
    <h6
        :class="
            twMerge(
                'whitespace-pre-line text-center text-[1rem] font-bold leading-[1.5] lg:text-[1.125rem]',
                locale === 'en' &&
                    'text-[1rem] leading-[1.1] tracking-[-0.03em] lg:text-[1.125rem]',
                locale === 'ja' && '',
                locale === 'ko' && '',
                $attrs.class,
            )
        "
    >
        <slot />
    </h6>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
const { locale } = useI18n();
</script>
